import { FC } from 'react';
import UserProfile from '../../../UserProfile';
import { CountrySelector as MayaCountrySelector } from 'components/CountrySelector/CountrySelector';
import { useCurrentUserState } from 'contexts/user';

const NavbarContent: FC = () => {
  const { user, userLoading } = useCurrentUserState();

  if (userLoading) {
    return null;
  }

  return user
    ? (
      <>
        <MayaCountrySelector user={ user } />
        <UserProfile user={ user } />
      </>
    )
    : (
      <UserProfile user={ user } />
    );
};

export default NavbarContent;
